function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurementSurface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 13.631174,3.967267 c -0.116553,2.537525 -0.639377,7.695826 -2.967106,7.695826 -1.55848,0 -2.277778,-1.798246 -2.973766,-3.53988 -0.612736,-1.535169 -1.248782,-3.12029 -2.35437,-3.12029 -1.488548,0 -2.157895,3.91618 -2.304419,7.04979 0.556124,0.159844 0.969055,0.666017 0.969055,1.275423 0,0.735949 -0.596085,1.332034 -1.332034,1.332034 -0.735949,0 -1.332034,-0.596085 -1.332034,-1.332034 0,-0.632716 0.442901,-1.15887 1.032326,-1.295403 0.116553,-2.537525 0.636047,-7.695827 2.967106,-7.695827 1.55848,0 2.277778,1.798246 2.973766,3.539881 0.612736,1.535169 1.248782,3.120289 2.35437,3.120289 1.485218,0 2.157895,-3.91618 2.304419,-7.049789 -0.556124,-0.159845 -0.969055,-0.666017 -0.969055,-1.275423 0,-0.735949 0.596085,-1.332034 1.332034,-1.332034 0.735949,0 1.332034,0.596085 1.332034,1.332034 0,0.632716 -0.442901,1.15887 -1.032326,1.295403 z",
    id: "path1",
    style: {
      strokeWidth: 0.666017
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementSurface);
export default __webpack_public_path__ + "static/media/measurementSurface.f9b9ecf58214bbd80b8526417364ae70.svg";
export { ForwardRef as ReactComponent };